import React from 'react';
import QuoteMachine from './components/QuoteMachine';

function App() {
  return (
    <div className="App">
      <QuoteMachine />
    </div>
  );
}

export default App;
